import React, { useEffect } from "react";
import Hero from "components/user/home/Hero";
import ProgramDiajeng from "components/user/home/ProgramDiajeng";
import DataJateng from "components/user/home/DataJateng";
import FiturDiajeng from "components/user/home/FiturDiajeng";
import Berita from "components/user/home/ListBerita";
import FAQ from "components/user/home/FAQ";
import TestimoniDiajeng from "components/user/home/TestimoniDiajeng";

function About() {
  useEffect(() => {
    // Cek apakah URL memiliki hash #fitur
    if (window.location.hash === "#fitur") {
      setTimeout(() => {
        const fiturElement = document.getElementById("fitur");

        if (fiturElement) {
          fiturElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <div>
        <Hero />

        <ProgramDiajeng />

        <DataJateng />

        {/* Fitur Diajeng */}
        <section id="fitur" className="scroll-mt-20">
          <FiturDiajeng />
        </section>

        <Berita />

        <FAQ />

        <TestimoniDiajeng />
      </div>
    </>
  );
}

export default About;